import { utils } from '@broadleaf/admin-components';

/**
 * Trim the application objects to only id and name to prevent cache QuotaExceededErrors.
 */
utils.axios.interceptors.response.use(
  function (response) {
    if (
      response.config.url &&
      response.config.url.includes('/applications/customer-contexts')
    ) {
      const trimmedData = {};
      if (response.data && typeof response.data === 'object') {
        Object.keys(response.data).forEach(key => {
          const apps = response.data[key];
          if (Array.isArray(apps)) {
            trimmedData[key] = apps.map(app => ({
              id: app.id,
              name: app.name
            }));
          } else {
            trimmedData[key] = apps;
          }
        });
        response.data = trimmedData;
      }
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
